import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37fe1704"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-mini" }
const _hoisted_4 = {
  key: 0,
  ref: "appLauncherBtn",
  class: "header-mini__app-launcher"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-mini__title" }, "Live Leaderboards", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isQueryParamEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, null, 512))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          src: _ctx.company?.logo
        }, null, 8, _hoisted_5),
        _hoisted_6
      ]),
      _createVNode(_component_Avatar)
    ])
  ]))
}